module.exports = __webpack_public_path__ + "static/media/gwbilbord02.a06962a3.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/Goodwill/gwbilbord02.jpg
// module id = 379
// module chunks = 0